/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
            github
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="bio">
      <div className="bio-wrap">
        <div className="bio-inner">
          <StaticImage
            className="bio-avatar"
            layout="fixed"
            formats={["auto", "webp", "avif"]}
            src="https://pbs.twimg.com/profile_images/1607514213655904263/O6dNDgC0_400x400.jpg"
            width={70}
            height={70}
            quality={100}
            alt="Profile picture"
          />
          {author?.name && (
            <div>
              <div className="author-name">{author.name}</div>
              <div className="author-summary">{author?.summary || null}</div>
              <div className="author-sns-area">
                <div className="author-sns-twitter-wrap">
                  <a className="bio-twitter-link" href={`https://twitter.com/${social?.twitter || ``}`} target="_blank" rel="noreferrer">
                    <StaticImage
                      className="twitter-icon"
                      layout="fixed"
                      formats={["auto", "webp", "avif"]}
                      src="../assets/images/twitter-logo.png"
                      width={21}
                      height={17}
                      quality={100}
                      alt="Profile picture"
                    />
                    <span className="twitter-user-name">
                      @homio_tty
                    </span>
                  </a>
                </div>
                <div className="author-sns-github-wrap">
                  <a className="bio-github-link" href={`https://github.com/${social?.github || ``}`} target="_blank" rel="noreferrer">
                    <StaticImage
                      className="github-icon"
                      layout="fixed"
                      formats={["auto", "webp", "avif"]}
                      src="../assets/images/github-mark.png"
                      width={17}
                      height={17}
                      quality={100}
                      alt="Profile picture"
                    />
                    <span className="github-user-name">
                      homio13
                    </span>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Bio
